module.exports = __webpack_public_path__ + "static/media/header-checkerboard-upload-check.3e63c6f4.svg";